import s from "../clinic.module.css";
import { Button, FormSection } from "../../ui";
import TrainerAssignmentsFields, { toggleId } from "../AdminTeam/TrainerAssignmentsFields";

export default function AdminDoctorBranchesForm({
  groups = [],
  groupIds = [],
  onChangeAssignments,
  onSave,
}) {
  const setAssignments = (patch) => {
    onChangeAssignments?.(patch);
  };

  return (
    <>
      {groups.length > 0 && onChangeAssignments ? (
        <FormSection
          title="Группы"
          description="Тренер ведёт выбранные группы — видит их занятия в расписании и журнале"
        >
          <TrainerAssignmentsFields
            groupsOnly
            groups={groups}
            groupIds={groupIds}
            onToggleGroup={(id) =>
              setAssignments({ groupIds: toggleId(groupIds, id) })
            }
          />
        </FormSection>
      ) : (
        <p className={s.attachmentHint}>Сначала создайте группу в разделе «Группы».</p>
      )}

      <Button type="button" style={{ marginTop: 16 }} onClick={onSave}>
        Сохранить
      </Button>
    </>
  );
}
